import React from 'react';
import {
  AccessorizedView,
  type AccessorizedProps,
} from 'src/components/layout/AccessorizedView/AccessorizedView';
import { Divider } from '../Divider';
import {
  CardHeaderDividerContainerStyled,
  CardHeaderStyled,
} from './CardHeader.styles';

export interface CardHeaderProps
  extends
    AccessorizedProps,
    Omit<
      React.ComponentPropsWithoutRef<typeof CardHeaderStyled>,
      'hasDivider'
    > {
  hasDivider?: boolean;
}

export const CardHeader = ({
  children,
  startAccessory,
  startAccessoryProps,
  endAccessory,
  endAccessoryProps,
  hasDivider = true,
  ...props
}: CardHeaderProps) => {
  return (
    <CardHeaderStyled
      {...props}
      hasDivider={hasDivider}
      data-testid="test-card-header"
    >
      <AccessorizedView
        gap={2}
        startAccessory={startAccessory}
        startAccessoryProps={startAccessoryProps}
        endAccessory={endAccessory}
        endAccessoryProps={endAccessoryProps}
        data-testid="test-accessorized-view"
      >
        {children}
      </AccessorizedView>
      {hasDivider && (
        <CardHeaderDividerContainerStyled data-testid="test-divider-container">
          <Divider variant="horizontal" />
        </CardHeaderDividerContainerStyled>
      )}
    </CardHeaderStyled>
  );
};
